// extracted by mini-css-extract-plugin
export default {"generaltable":"SelectedSicknessReport_generaltable__JAjv3"};